// Centros Penitenciarios y de Reinserción Social (CPRS) del Estado de México.
// Data hardcoded porque el backend no expone un endpoint para estos puntos
// estáticos. Migrada desde Map.vue legacy (líneas 2032-2294).
//
// Estructura por item:
//   id:                   número estable (se usa como monitor id: 'cpr-{id}')
//   name:                 nombre oficial del centro
//   latitude, longitude:  coordenadas reales de la ubicación
//   ubicacion:            dirección completa (calle, municipio, estado)
//   poblacion:            internos total al momento del censo
//   hombres, mujeres:     distribución por sexo (suma ≈ poblacion)
//   gruposDelictivosZona: array de grupos con presencia reportada en la zona
//
// Si cambian los valores en el futuro y deben venir del backend, basta con
// exponer un endpoint /api/cprs que devuelva el mismo shape y llamar al
// normalizer igual que se hace con cualquier otra entidad.

export const CPRS_DATA = [
  {
    id: 1,
    name: 'SANTIAGUITO',
    latitude: 19.33147,
    longitude: -99.73343,
    ubicacion: 'Cam. a Villa Almoloya de Juárez km 4.5, 51355 Santiaguito Tlalcilalcalli, Méx.',
    poblacion: 5181,
    hombres: 4476,
    mujeres: 705,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios'],
  },
  {
    id: 2,
    name: 'CHALCO',
    latitude: 19.22477,
    longitude: -98.91880,
    ubicacion: 'Carretera Mixquic - Chalco s/n, San Mateo Huitzilzingo, 56625 Chalco de Díaz Covarrubias, Méx.',
    poblacion: 3777,
    hombres: 3526,
    mujeres: 251,
    gruposDelictivosZona: ['Familia Michoacana'],
  },
  {
    id: 3,
    name: 'CUAUTITLÁN',
    latitude: 19.66882,
    longitude: -99.18122,
    ubicacion: 'Barracuda 119, Centro, 54800 Cuautitlán, Méx.',
    poblacion: 1186,
    hombres: 1186,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.', 'Los Zetas', 'Los Beltrán Leyva'],
  },
  {
    id: 4,
    name: 'ECATEPEC',
    latitude: 19.61951,
    longitude: -98.97398,
    ubicacion: 'Camino a Las Minas s/n, Sta Maria Chiconautla, 55068 Ecatepec de Morelos, Méx.',
    poblacion: 6126,
    hombres: 5694,
    mujeres: 432,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios', 'C.J.N.G.', 'Los Zetas', 'Guerreros Unidos', 'Cártel de Sinaloa', 'Cártel de los Beltrán'],
  },
  {
    id: 5,
    name: 'EL ORO',
    latitude: 19.80187,
    longitude: -100.13347,
    ubicacion: 'Galeana 6, El Oro de Hidalgo, 50600 El Oro de Hidalgo, Méx.',
    poblacion: 452,
    hombres: 452,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana'],
  },
  {
    id: 6,
    name: 'IXTLAHUACA',
    latitude: 19.56938,
    longitude: -99.76588,
    ubicacion: 'Calle Francisco López Rayón Pte. 402, Centro, 50740 Ixtlahuaca de Rayón, Méx.',
    poblacion: 474,
    hombres: 474,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.'],
  },
  {
    id: 7,
    name: 'JILOTEPEC',
    latitude: 19.95249,
    longitude: -99.53552,
    ubicacion: 'Jilotepec de Andrés Molina Enríquez, Jilotepec de Molina Enríquez, Méx.',
    poblacion: 443,
    hombres: 443,
    mujeres: 0,
    gruposDelictivosZona: ['Los Caballeros Templarios'],
  },
  {
    id: 8,
    name: 'LERMA',
    latitude: 19.28331,
    longitude: -99.51218,
    ubicacion: 'Av. Reolín Barejon 10, Centro, 52000 Lerma de Villada, Méx.',
    poblacion: 165,
    hombres: 165,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana'],
  },
  {
    id: 9,
    name: 'NEZAHUALCÓYOTL BORDO',
    latitude: 19.42414,
    longitude: -99.01438,
    ubicacion: 'Blvd. Adolfo López Mateos esquina Bordo de Xochiaca, 57000 Cdad. Nezahualcóyotl, Méx.',
    poblacion: 5921,
    hombres: 5479,
    mujeres: 442,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios', 'C.J.N.G.', 'La Unión Tepito', 'Los Zetas', 'Cártel de Sinaloa'],
  },
  {
    id: 10,
    name: 'OTUMBA TEPZCHICO',
    latitude: 19.68293,
    longitude: -98.74917,
    ubicacion: 'Carretera Tlalminilolpan Exhacienda Tepachico s/n , Otumba Centro, 55900, Méx.',
    poblacion: 1054,
    hombres: 1054,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.'],
  },
  {
    id: 11,
    name: 'SULTEPEC',
    latitude: 18.85935,
    longitude: -99.96721,
    ubicacion: 'Benito Juárez s/n, Calvario Sultepec, Barrio del Convento, 51600 Sultepec, Méx.',
    poblacion: 149,
    hombres: 149,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana'],
  },
  {
    id: 12,
    name: 'TENANCINGO CENTRO',
    latitude: 18.96177,
    longitude: -99.59366,
    ubicacion: 'México 55 24, Centro, 52400 Tenancingo de Degollado, Méx.',
    poblacion: 336,
    hombres: 336,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.'],
  },
  {
    id: 13,
    name: 'TENANGO DEL VALLE',
    latitude: 19.12326,
    longitude: -99.59894,
    ubicacion: '52315 Tenango de Arista, Méx.',
    poblacion: 1333,
    hombres: 1333,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana'],
  },
  {
    id: 14,
    name: 'TEXCOCO',
    latitude: 19.51399,
    longitude: -98.83242,
    ubicacion: 'Carretera San Miguel Tlaixpan km. 4.5, San Miguel Tlaixpan, 56247 Texcoco, Méx.',
    poblacion: 1880,
    hombres: 1818,
    mujeres: 62,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios', 'C.J.N.G.', 'Cártel de Tláhuac'],
  },
  {
    id: 15,
    name: 'TLALNEPANTLA',
    latitude: 19.58476,
    longitude: -99.19058,
    ubicacion: 'Av. Ejercito del Trabajo S/N, San Pedro Barrientos, 54010 Tlalnepantla, Méx.',
    poblacion: 5856,
    hombres: 5353,
    mujeres: 503,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.', 'La Unión Tepito', 'Los Zetas', 'Cártel de Sinaloa'],
  },
  {
    id: 16,
    name: 'VALLE DE BRAVO',
    latitude: 19.20264,
    longitude: -100.13710,
    ubicacion: 'S. Antonio Marzana 011, San Antonio, 51200 Valle de Bravo, Méx.',
    poblacion: 412,
    hombres: 412,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'Guerreros Unidos'],
  },
  {
    id: 17,
    name: 'ZUMPANGO',
    latitude: 19.79654,
    longitude: -99.10076,
    ubicacion: 'Plaza Juárez s/n Barrio de San Juan, Interior Palacio Municipal, Méx.',
    poblacion: 760,
    hombres: 760,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.'],
  },
  {
    id: 18,
    name: 'NEZAHUALCÓYOTL NORTE',
    latitude: 19.38855,
    longitude: -98.98983,
    ubicacion: 'Manzana 021, La Perla, 57820 Cdad. Nezahualcóyotl, Méx.',
    poblacion: 209,
    hombres: 209,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios', 'C.J.N.G.', 'La Unión Tepito', 'Los Zetas', 'Cártel de Sinaloa'],
  },
  {
    id: 19,
    name: 'NEZAHUALCÓYOTL SUR',
    latitude: 19.37834,
    longitude: -98.99417,
    ubicacion: 'Av. B Manzana 001, Nueva Santa Martha, 57100 Cdad. Nezahualcóyotl, Méx.',
    poblacion: 374,
    hombres: 0,
    mujeres: 374,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios', 'C.J.N.G.', 'La Unión Tepito', 'Los Zetas', 'Cártel de Sinaloa'],
  },
  {
    id: 20,
    name: 'PENITENCIARÍA MODELO',
    latitude: 19.38157,
    longitude: -98.98849,
    ubicacion: 'Ave. Pte. 10 entre Norte 1 y Calle Nte. 2, La Perla, 57830 Nezahualcóyotl, Méx.',
    poblacion: 82,
    hombres: 82,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'Caballeros Templarios', 'C.J.N.G.', 'La Unión Tepito', 'Los Zetas', 'Cártel de Sinaloa'],
  },
  {
    id: 21,
    name: 'INTERNAMIENTO ADOLESCENTES',
    latitude: 19.27636,
    longitude: -99.74773,
    ubicacion: '51354 San Miguel Zinacantepec, Méx.',
    poblacion: 306,
    hombres: 306,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'Guerreros Unidos'],
  },
  {
    id: 22,
    name: 'TENANCINGO SUR',
    latitude: 18.95300,
    longitude: -99.58715,
    ubicacion: 'Héctor Gordillo 109, Tenancingo de Degollado, La Ciénega, Méx.',
    poblacion: 1527,
    hombres: 1527,
    mujeres: 0,
    gruposDelictivosZona: ['Familia Michoacana', 'C.J.N.G.'],
  },
]
